var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"white","padding":"5px"}},[_c('b',[_vm._v(_vm._s(_vm.item.UF_NUMBER))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.item.UF_NAME))])])
}
var staticRenderFns = []

export { render, staticRenderFns }